export enum TravelInsuranceType {
  TRAVEL_SUPER = "travelSuper",
  TRAVEL_STANDARD = "travelStandard",
}
